import { Component } from '@angular/core';

@Component({
  templateUrl: './pois.page.html',
  styleUrls: ['./pois.page.scss'],
})
export class PoisPage {
  constructor() {}
}
